import { useAuth } from '../contexts/AuthContext'

/**
 * Papel do usuário logado + flags de permissão de UI.
 *
 * Regra de produto: **viewer é read-only** — não deve ver ações destrutivas (excluir)
 * em lugar nenhum (usuários, devices, VMs/managed devices, routers, hosts, etc.).
 * Gestão de usuários (excluir usuário) fica restrita a admin/owner/global.
 *
 * Observação: isto é apenas gating de UI; o backend continua sendo a fonte de verdade
 * de autorização nos endpoints.
 */
export function useRole() {
  const { user } = useAuth()
  const role = String(user?.role || user?.Role || '').toLowerCase()
  const isGlobal = Boolean(user?.isGlobalUser || user?.IsGlobalUser)

  const isViewer = role === 'viewer'
  const isOperator = role === 'operator'
  const isAdmin = isGlobal || role === 'owner' || role === 'admin'

  return {
    role,
    isGlobal,
    isViewer,
    isOperator,
    isAdmin,
    /** Pode ver/usar ações de excluir recursos (devices, VMs, routers, etc.). Viewer não pode. */
    canDelete: isGlobal || !isViewer,
    /** Pode gerir usuários (excluir usuário). Restrito a admin/owner/global. */
    canManageUsers: isAdmin,
  }
}

export default useRole
